import TopNavBar from '../../components/reusables/topNavBar';
import ProductTable from './components/productTable';

function Storage() {
    return (
        <div className='h-full flex flex-col'>
            <TopNavBar title={"Estoque"} subtitle={"Gerencie o seu estoque geral."} />
            <div className='mx-4 sm:mx-10 my-6 flex-1 font-poppins text-custom_lighter_gray_font'>
                <ProductTable />
            </div>
        </div>
    )

}

export default Storage